import api from './api';

export async function getMyVenues(organiser = false) {
  const response = await api.get(organiser ? '/venue-organisers/venues' : '/venues/owner');
  return response.data;
}

export async function getVenueById(id) {
  const response = await api.get(`/venues/${id}`);
  return response.data;
}

export async function createVenue(data) {
  const response = await api.post('/venues', data);
  return response.data;
}

export async function deleteVenue(id) {
  const response = await api.delete(`/venues/${id}`);
  return response.data;
}

export async function updateVenue(id, data) {
  const response = await api.put(`/venues/${id}`, data);
  return response.data;
}

export async function uploadPhoto(venueId, file) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/venues/${venueId}/photos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function addAmenity(venueId, name) {
  const response = await api.post(`/venues/${venueId}/amenities`, { name });
  return response.data;
}

export async function removeAmenity(venueId, amenityId) {
  const response = await api.delete(`/venues/${venueId}/amenities/${amenityId}`);
  return response.data;
}

const DAY_MAP = {
  monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday',
  thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
};

export async function setOperatingHours(venueId, hours) {
  const hoursArray = Object.entries(hours).flatMap(([key, val]) => {
    if (!val.isOpen) {
      return [{ dayOfWeek: DAY_MAP[key], openTime: '00:00', closeTime: '00:00', isClosed: true }];
    }

    if (val.is24Hours) {
      return [{ dayOfWeek: DAY_MAP[key], openTime: '00:00', closeTime: '00:00', isClosed: false, is24Hours: true }];
    }
    return (val.windows || []).map((window) => ({
      dayOfWeek: DAY_MAP[key],
      openTime: window.open,
      // HTML time inputs use 00:00 for midnight, but accept 24:00 from
      // imported/manual values. The API stores both as next-day midnight.
      closeTime: window.close === '24:00' ? '00:00' : window.close,
      isClosed: false,
    }));
  });
  const response = await api.put(`/venues/${venueId}/hours`, hoursArray);
  return response.data;
}
